import type { CreateSessionRequest } from '@xpanse/ui';

import { useMutation } from '@tanstack/react-query';

import { AuthService } from 'src/utils/services';

const createSession = async (data: CreateSessionRequest): Promise<string> => {
  const response = await AuthService.createSession(data);
  return response;
};

export function useCreateSession() {
  const { mutate } = useMutation({
    mutationFn: createSession,
    onSuccess: (sessionId) => {
      localStorage.setItem('sessionId', sessionId);
    },
  });

  return { createSession: mutate };
}
